var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("strong", [_vm._v(_vm._s(_vm.$t("txtPoiList")))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "vue-good-table",
                  {
                    attrs: {
                      columns: _vm.columnsConfig,
                      rows: _vm.pois,
                      "pagination-options": {
                        enabled: true,
                        nextLabel: _vm.$t("txtNext"),
                        prevLabel: _vm.$t("txtPrev"),
                        rowsPerPageLabel: _vm.$t("txtPagePer"),
                        ofLabel: _vm.$t("txtOf"),
                        pageLabel: _vm.$t("txtPage"),
                        allLabel: _vm.$t("txtAll")
                      },
                      "search-options": {
                        enabled: true,
                        placeholder: _vm.$t("txtFilter")
                      }
                    },
                    on: { "on-row-click": _vm.onRowClick }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "emptystate" }, slot: "emptystate" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("txtSearchNoRows")) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-default",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("Close")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }